import * as React from 'react'

import { Box, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'

import ModuleCard from './_ModuleCard'

const ModulesList = () => {
  const { allPlans } = usePricingContext()

  if (!allPlans.normalPlans.length) return <Spinner />

  return (
    <Box gap="s48">
      <Box gap="s24">
        <Text size="400" color="grey1000" weight="semibold">
          {i18n.t('pricing_plans.custom_bundles.first_step')}
        </Text>
        {allPlans.corePlans.map((plan) => (
          <ModuleCard plan={plan} icon="logo-avatar" key={plan.title} isCore />
        ))}
      </Box>
      <Box gap="s24">
        <Text size="400" color="grey1000" weight="semibold">
          {i18n.t('pricing_plans.custom_bundles.second_step')}
        </Text>
        <Box gap="s16">
          {allPlans.normalPlans.map((plan) => (
            <ModuleCard icon={plan.icon} plan={plan} key={plan.title} />
          ))}
        </Box>
      </Box>
    </Box>
  )
}

export default ModulesList
